module.exports = __webpack_public_path__ + "img/service.9c7e876b.png";